module.exports = "https://static.wanderu.com/ui-react/_next/static/media/it.9938f4b9.svg";